import { createSelector } from '@ngrx/store';
import * as statementsMainReducer from '../employee-detail.reducer';
import * as previousStatementsSubState from '../reducers/previous-statements.reducer';

export const selectPreviousStatements = createSelector(
  statementsMainReducer.getPreviousStatementsState,
  previousStatementsSubState.getPreviousStatements
);
